import dayjs from "dayjs";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { activeModule } from "../active-module";
import { toast } from "react-toastify";

const DISMISS_COOLDOWN_DAYS = 5;

interface UpdateNotificationState {
  dismissedAt: string | null;
  dismiss: () => void;
  shouldShow: () => boolean;
}

export const useUpdateNotificationStore = create<UpdateNotificationState>()(
  persist(
    (set, get) => ({
      dismissedAt: null,

      dismiss: () => {
        set({ dismissedAt: new Date().toISOString() });
      },

      shouldShow: () => {
        const { dismissedAt } = get();
        if (!dismissedAt) return true;

        const diffDays = dayjs().diff(dayjs(dismissedAt), "day", true);
        toast.info(`diffDays: ${diffDays}`);

        return diffDays >= DISMISS_COOLDOWN_DAYS;
      },
    }),
    {
      name: `${activeModule}-update-notification`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
